import axios from 'axios';
import { param } from 'jquery';
import { filter } from 'lodash';
import { Modal } from 'ant-design-vue';
import i18n from '@/i18n';

export const SCU_API_URL = `${process.env.VUE_APP_SCU_API_URL}`;

export function fetchToken({
  instance,
  username,
  password,
  returnUrl,
}) {
  return axios({
    method: 'POST',
    url: `${SCU_API_URL}/users/${instance}/token`,
    data: {
      instance,
      username,
      password,
      returnUrl,
      projectType: 'ACCESS',
    },
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => response.data);
}

export function fetchUser({
  token,
  username,
}) {
  return axios({
    method: 'GET',
    url: `${SCU_API_URL}/users`,
    params: {
      username,
    },
    headers: {
      Authorization: token,
    },
  }).then(response => response.data[0]);
}

export function fetchUserWithRefererAuth({
  mail,
  username,
  instance,
  referer,
}) {
  return axios({
    method: 'GET',
    url: `${SCU_API_URL}/users`,
    params: {
      mail,
      username,
      instance,
    },
    headers: {
      'Referer-Full-Url': referer,
    },
  }).then(response => response.data[0]);
}

export function searchUsersBy({
  token,
  mail,
}) {
  return axios({
    method: 'GET',
    url: `${SCU_API_URL}/users/search-by`,
    params: {
      mail,
    },
    headers: {
      Authorization: token,
    },
  }).then(response => response.data);
}

export function fetchRestorePasswordLink({
  userId,
  userMail,
  userName,
  instance,
  userUsername,
  redirectUrl,
  locale,
  autoLogin,
}) {
  return axios({
    method: 'GET',
    url: `${SCU_API_URL}/users/restore-password-link`,
    params: {
      userId,
      userMail,
      userName,
      instance,
      userUsername,
      redirectUrl,
      locale,
      autoLogin,
    },
  }).then(response => response.data);
}

export function sendMailViaScuApi({
  subject,
  text,
  to,
  referer,
}) {
  return axios({
    method: 'POST',
    url: `${SCU_API_URL}/utils/mail`,
    data: {
      subject,
      text,
      to,
    },
    headers: {
      'Referer-Full-Url': referer,
    },
  }).then(response => response.data);
}

export function updateUser({
  token,
  id,
  name,
  mail,
  audit: {
    userId,
  },
}) {
  return axios({
    method: 'PUT',
    url: `${SCU_API_URL}/users`,
    data: {
      id,
      name,
      mail,
      audit: {
        userId,
      },
    },
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }).then(response => response.data);
}

export function restoreUserPassword({
  token,
  userEntity,
}) {
  return axios({
    method: 'PUT',
    url: `${SCU_API_URL}/users/`,
    data: {
      ...userEntity,
      passwordMustBeRestored: true,
    },
    headers: {
      Authorization: token,
    },
  }).then(response => response.data);
}

export function restoreUserPasswordWithRefererAuth({
  instance,
  userEntity,
  referer,
}) {
  return axios({
    method: 'PUT',
    url: `${SCU_API_URL}/users/`,
    data: {
      ...userEntity,
      passwordMustBeRestored: true,
    },
    params: {
      instance,
    },
    headers: {
      'Referer-Full-Url': referer,
    },
  }).then(response => response.data);
}

export function fetchProfilers({
  token,
  userId,
  projectId,
}) {
  return axios({
    method: 'GET',
    url: `${SCU_API_URL}/profilers`,
    params: {
      userId,
      projectId,
      excludedFields: 'userEntity,alerts,dbPassword,permissions',
    },
    headers: {
      Authorization: token,
    },
  }).then(response => filter(response.data, {
    enabled: 1,
  }));
}

export async function saveLogin({
  token,
  data,
}) {
  return axios({
    method: 'POST',
    url: `${SCU_API_URL}/logins`,
    data,
    headers: {
      Authorization: token,
    },
  });
}

export function doLoginIntoIwrs({
  instance,
  profilerId,
  token,
  redirectUrl,
}) {
  const params = param({
    instance,
    profilerId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });

  return `/iwrs-app/#/login-bridge?${params}`;
}

export function doLoginIntoIwrsLevel({
  instance,
  profilerId,
  token,
  redirectUrl,
}) {
  const params = param({
    instance,
    profilerId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });

  return `/iwrs-level-app/#/login-bridge?${params}`;
}

export function doLoginIntoErp({
  profilerId,
  userId,
  token,
  redirectUrl,
}) {
  const params = param({
    profilerId,
    userId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });
  return `/erp/#/login-bridge?${params}`;
}

export function doLoginIntoEventsPlatform({
  userId,
  token,
  redirectUrl,
}) {
  const params = param({
    userId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });
  return `/events-platform/#/login-bridge?${params}`;
}

export function doLoginIntoNexus({
  instance,
  profilerId,
  token,
  redirectUrl,
}) {
  const params = param({
    instance,
    profilerId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });
  return `/nexus/#/login-bridge?${params}`;
}

export function doLoginIntoTmf({
  instance,
  profilerId,
  token,
  redirectUrl,
}) {
  const params = param({
    instance,
    profilerId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });
  return `/tmf/#/login-bridge?${params}`;
}

export async function doLoginIntoExportNext({
  crdProjectId,
  instance,
  userId,
  token,
  redirectUrl,
}) {
  const crdProfilers = await fetchProfilers({
    token: `${token.token_type} ${token.access_token}`,
    userId,
    projectId: crdProjectId,
  });

  // multi-profiler now allowed for export-next
  const crdProfiler = crdProfilers[0];

  const params = param({
    instance,
    profilerId: crdProfiler.id,
    userId,
    token_type: token && token.token_type,
    access_token: token && token.access_token,
    redirectUrl,
  });

  return `/crd-export-next/#/login-bridge?${params}`;
}

export async function dologinIntoCrd({
  instance,
  projectId,
  token,
  username,
  profileId,
  organizationId,
  redirectUrl,
}) {
  const CE_HOME_URL = `${process.env.VUE_APP_CE_HOME_URL}`;
  const CE_API_URL = `${process.env.VUE_APP_CE_API_URL}`;

  try {
    await axios({
      method: 'POST',
      url: `${CE_API_URL}/login?redirectUrl=${redirectUrl}`,
      data: {
        instance,
        username,
        profileId,
        organizationId,
        scuTokenData: {
          token_type: token.token_type,
          access_token: token.access_token,
        },
        scuProjectBean: {
          id: projectId,
        },
      },
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
  } catch (error) {
    if (error.response && error.response.status === 401) {
      const modal = Modal.warning();
      modal.update({
        title: i18n.t('api.do_login_into_crd.error_title'),
        content: i18n.t('api.do_login_into_crd.error_message'),
        okText: i18n.t('api.do_login_into_crd.exit'),
        okType: 'primary',
        maskClosable: false,
        keyboard: false,
        onOk: async () => {
          document.getElementById('do-logout').click();
        },
      });

      return '';
    }
  }

  return CE_HOME_URL;
}

export async function doLoginIntoCmi({
  instance,
  crdProjectDbUsername,
  crdProjectId,
  crdProjectProfileId,
  crdProjectOrganizationId,
  token,
  username,
  redirectUrl,
  userId,
  projectTitle,
}) {
  debugger;

  const location = await dologinIntoCrd({
    instance,
    projectId: crdProjectId,
    profileId: crdProjectProfileId,
    organizationId: crdProjectOrganizationId,
    token,
    username,
    redirectUrl,
  });

  if (!location) {
    return '';
  }

  const CE_URL = `${process.env.VUE_APP_CE_URL}`;
  const {
    data,
  } = await axios(`${CE_URL}/idcmi`);

  const params = param({
    param: data,
    project: crdProjectDbUsername,
    projectPk: crdProjectId,
    logo: 'TEST',
    title: projectTitle,
    ceproject: 1,
    userId,
    scuTokenData: {
      access_token: token.access_token,
      token_type: token.token_type,
    },
  });

  return `/cmi/autologin?${params}`;
}
